export interface IHueTextInputProps
	extends React.HTMLAttributes<HTMLInputElement> {
	hint: string;
}

export interface IInputActionStates {
	hovered: boolean;
	focused: boolean;
	active: boolean;
}

export interface IInputAction {
	type: 'hovered' | 'focused';
	value: boolean;
}

export enum ACTIONS {
	IS_HOVERED = 'hovered',
	IS_FOCUSED = 'focused',
}
